import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
// /nom-bonic-programa/capitols/

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS, 'programa', 'capitols']);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);

    if (__isEmpty(mapping) || !mapping.id) {
        return {
            notFound: true
        };
    }

    let path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'capitols'];
    const customCapitols = ['telenoticies'];

    if (!__isEmpty(mapping) && customCapitols.includes(slug)) {
        path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'custom', '' + mapping.id, 'capitols'];
    }

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
